import React from "react";
import { AvatarStack } from "../AvatarStack";
import {
  CollaboratorsList,
  CollaboratorRow,
  Identity,
  Name,
  Email,
  RoleGroup,
  RoleText,
  StatusText,
  EmptyText,
  ErrorText,
} from "./StoryCollaboratorsList.styles";
import type { StoryCollaboratorsListProps } from "./StoryCollaboratorsList.types";

const AVATAR_SIZE = 32;

/**
 * Collaborators dropdown body for the story header: avatar, name + email and
 * role per person — the same fields as the Share modal's member list.
 * Stateless; rows arrive already shaped.
 */
export const StoryCollaboratorsList: React.FC<StoryCollaboratorsListProps> = ({
  collaborators,
  isLoading = false,
  loadingText = "Loading collaborators…",
  errorMessage = null,
}) => (
  <CollaboratorsList data-testid="story-collaborators-list">
    {isLoading ? (
      <EmptyText role="status">{loadingText}</EmptyText>
    ) : errorMessage ? (
      <ErrorText role="alert">{errorMessage}</ErrorText>
    ) : collaborators.length === 0 ? (
      <EmptyText>No collaborators yet</EmptyText>
    ) : (
      collaborators.map((person) => (
        <CollaboratorRow key={person.id} data-testid={`collaborator-${person.id}`}>
          <AvatarStack
            members={[{ id: person.id, name: person.name, avatarUrl: person.avatarUrl }]}
            size={AVATAR_SIZE}
          />
          <Identity>
            <Name>{person.name}</Name>
            <Email>{person.email}</Email>
          </Identity>
          <RoleGroup>
            <RoleText>{person.roleLabel}</RoleText>
            {person.statusLabel && <StatusText>{person.statusLabel}</StatusText>}
          </RoleGroup>
        </CollaboratorRow>
      ))
    )}
  </CollaboratorsList>
);

export default StoryCollaboratorsList;
